import _ from 'lodash';
import React from 'react';
import Slider from './innerComponents/Slider';
import Sponsor from './innerComponents/Sponsor';
import './SponsorsCarousel.scss';

export default class SponsorsCarousel extends React.Component {
    render() {
        if (!this.props.sponsors.length) return null;

        let sponsors = [];

        let normal = _(this.props.sponsors).filter({featured: false}).value(),
            featured = _(this.props.sponsors).filter({featured: true}).value();

        if (featured.length) {
            let selectedFeatured = _(featured).sample();
            sponsors.push(<Sponsor eventId={this.props.eventId} sponsor={selectedFeatured} key="featured1" />);

            if (!normal.length && featured.length > 1) {
                let anotherFeatured = _(featured).reject({id: selectedFeatured.id}).sample();
                sponsors.push(<Sponsor eventId={this.props.eventId} sponsor={selectedFeatured} key="featured2" />);
            } else {
                sponsors.push(<Slider eventId={this.props.eventId} key="unsponsored" sponsors={normal} />);
            }
        } else {
            sponsors.push(
                <Slider
                    eventId={this.props.eventId}
                    key="unsponsored1"
                    sponsors={_(normal)
                        .filter((sponsor, i) => {
                            return i % 2;
                        })
                        .value()}
                />
            );
            sponsors.push(
                <Slider
                    eventId={this.props.eventId}
                    key="unsponsored2"
                    sponsors={_(normal)
                        .reject((sponsor, i) => {
                            return i % 2;
                        })
                        .value()}
                />
            );
        }

        sponsors = _.shuffle(sponsors);
        return <div className="SponsorsCarousel">{sponsors}</div>;
    }
}
